import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "relative flex-1 flex flex-col max-w-xs w-full bg-white" }
const _hoisted_2 = { class: "absolute top-0 right-0 -mr-12 pt-2" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("span", { class: "sr-only" }, "Close sidebar", -1)
const _hoisted_4 = { class: "flex-1 h-0 pt-5 pb-4 overflow-y-auto" }
const _hoisted_5 = { class: "flex-shrink-0 flex items-center px-4" }
const _hoisted_6 = { class: "mt-5 px-2 space-y-1" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "flex-shrink-0 w-14" }, null, -1)
const _hoisted_8 = { class: "hidden md:flex md:flex-shrink-0" }
const _hoisted_9 = { class: "flex flex-col flex-col w-55 pt-8 pb-4 shadow-modal bg-white overflow-y-auto scrollbar-thin scrollbar-thumb-green-medium scrollbar-track-gray-100" }
const _hoisted_10 = { class: "flex items-center flex-shrink-0 px-4" }
const _hoisted_11 = { class: "mt-16 flex-1 px-4 bg-white space-y-6" }

import { PropType } from 'vue';
import {
  Dialog,
  DialogOverlay,
  TransitionChild,
  TransitionRoot,
} from '@headlessui/vue';
import { XIcon } from '@heroicons/vue/outline';
import SidebarIcon from './icons/SidebarIcon.vue';
import Logo from './icons/Logo.vue';
import { NavigationLinks } from '../types/NaviagttionLinks';


export default /*#__PURE__*/_defineComponent({
  props: {
  sidebarOpen: {
    type: Boolean,
    required: true,
  },
  navigation: {
    type: Array as PropType<NavigationLinks>,
    required: false,
  },
},
  emits: ['closeSidebar'],
  setup(__props, { emit }) {





return (_ctx: any,_cache: any) => {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(TransitionRoot), {
      as: "template",
      show: __props.sidebarOpen
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Dialog), {
          as: "div",
          static: "",
          class: "fixed inset-0 flex z-40 md:hidden",
          open: __props.sidebarOpen,
          onClose: _cache[2] || (_cache[2] = ($event: any) => (emit('closeSidebar')))
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition-opacity ease-linear duration-300",
              "enter-from": "opacity-0",
              "enter-to": "opacity-100",
              leave: "transition-opacity ease-linear duration-300",
              "leave-from": "opacity-100",
              "leave-to": "opacity-0"
            }, {
              default: _withCtx(() => [
                _createVNode(_unref(DialogOverlay), { class: "fixed inset-0 bg-gray-600 bg-opacity-75" })
              ]),
              _: 1
            }),
            _createVNode(_unref(TransitionChild), {
              as: "template",
              enter: "transition ease-in-out duration-300 transform",
              "enter-from": "-translate-x-full",
              "enter-to": "translate-x-0",
              leave: "transition ease-in-out duration-300 transform",
              "leave-from": "translate-x-0",
              "leave-to": "-translate-x-full"
            }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(_unref(TransitionChild), {
                    as: "template",
                    enter: "ease-in-out duration-300",
                    "enter-from": "opacity-0",
                    "enter-to": "opacity-100",
                    leave: "ease-in-out duration-300",
                    "leave-from": "opacity-100",
                    "leave-to": "opacity-0"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_2, [
                        _createElementVNode("button", {
                          class: "ml-1 flex items-center justify-center h-10 w-10 rounded-full focus:outline-none focus:ring-2 focus:ring-inset focus:ring-white",
                          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('closeSidebar')))
                        }, [
                          _hoisted_3,
                          _createVNode(_unref(XIcon), {
                            class: "h-6 w-6 text-white",
                            "aria-hidden": "true"
                          })
                        ])
                      ])
                    ]),
                    _: 1
                  }),
                  _createElementVNode("div", _hoisted_4, [
                    _createElementVNode("div", _hoisted_5, [
                      _createVNode(Logo, { class: "w-full h-auto" })
                    ]),
                    _createElementVNode("nav", _hoisted_6, [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigation, (item, idx) => {
                        return (_openBlock(), _createBlock(_component_router_link, {
                          key: idx,
                          to: item.href,
                          "active-class": "bg-gray-100 text-gray-900 hover:bg-gray-100 hover:text-gray-900",
                          class: "text-gray-600 hover:bg-gray-50 hover:text-gray-900 group flex items-center px-2 py-2 text-base font-medium rounded-md",
                          onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('closeSidebar'))),
                          exact: ""
                        }, {
                          default: _withCtx(({ isActive }) => [
                            _createVNode(SidebarIcon, {
                              name: item.icon,
                              class: _normalizeClass([
                      isActive
                        ? 'text-gray-500'
                        : 'text-gray-400 group-hover:text-gray-500',
                      'mr-4 flex-shrink-0 h-6 w-6',
                    ]),
                              "aria-hidden": "true"
                            }, null, 8, ["name", "class"]),
                            _createTextVNode(" " + _toDisplayString(item.name), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"]))
                      }), 128))
                    ])
                  ])
                ])
              ]),
              _: 1
            }),
            _hoisted_7
          ]),
          _: 1
        }, 8, ["open"])
      ]),
      _: 1
    }, 8, ["show"]),
    _createElementVNode("aside", _hoisted_8, [
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(Logo, { class: "w-full h-auto" })
        ]),
        _createElementVNode("nav", _hoisted_11, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.navigation, (item, idx) => {
            return (_openBlock(), _createBlock(_component_router_link, {
              key: idx,
              to: item.href,
              class: "text-wrh-blue-400 hover:bg-wrh-gray-400 hover:text-white group flex items-center px-4 py-3 text-base font-medium rounded-md transition-color duration-200 ease-in-out",
              "active-class": "!bg-wrh-blue-600 !text-white hover:!bg-wrh-blue-600 hover:!text-white",
              exact: ""
            }, {
              default: _withCtx(({ isActive }) => [
                _createVNode(SidebarIcon, {
                  name: item.icon,
                  class: _normalizeClass([
                isActive
                  ? 'text-white'
                  : 'text-wrh-blue-400 group-hover:text-white',
                'mr-4 flex-shrink-0 h-6 w-6 transition-color duration-200 ease-in-out',
              ]),
                  "aria-hidden": "true"
                }, null, 8, ["name", "class"]),
                _createTextVNode(" " + _toDisplayString(item.name), 1)
              ]),
              _: 2
            }, 1032, ["to"]))
          }), 128))
        ])
      ])
    ])
  ], 64))
}
}

})